import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import Notice from '../views/notice/index.vue'
import History from '../views/history/index.vue'
import Source from '../views/source/index.vue'
import Relation from '../views/relation/index.vue'
import Ebook from '../views/ebook/index.vue'
import Audio from '../views/audio/index.vue'
import Webnew from '../views/webnew/index.vue'
import Preview from '../views/preview/index.vue'
import Commemorate from '../views/commemorate/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '吕正操研学中心',
      keepAlive: true
    }
  },
  {
    path: '/news',
    name: 'Notice',
    component: Notice,
    meta: {
      title: '公告'
    }
  },
  {
    path: '/history',
    name: 'History',
    component: History,
    meta: {
      title: '光辉事迹'
    }
  },
  {
    path: '/source',
    name: 'Source',
    component: Source,
    meta: {
      title: '数字藏品'
    }
  },
  {
    path: '/book',
    name: 'Ebook',
    component: Ebook,
    meta: {
      title: '书目推荐'
    }
  },
  {
    path: '/commemorate',
    name: 'Commemorate',
    component: Commemorate,
    meta: {
      title: '网上纪念'
    }
  },
  {
    path: '/relation',
    name: 'Relation',
    component: Relation,
    meta: {
      title: '关系图谱',
      keepAlive: true
    }
  },
  {
    path: '/audio',
    name: 'Audio',
    component: Audio,
    meta: {
      title: '音频',
      keepAlive: true
    }
  },
  {
    path: '/webnews',
    name: 'Webnew',
    component: Webnew,
    meta: {
      title: '追思缅怀'
    }
  },
  {
    path: '/libvr',
    name: 'Preview',
    component: Preview,
    meta: {
      title: '全景漫游'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
